var map = {
	"./announcing_laos.md": [
		4138,
		138
	],
	"./bridgeless_minting_ethereum_polygon_other_chains.md": [
		4393,
		393
	],
	"./digital_assets_use_cases_1_collectibles.md": [
		2234,
		234
	],
	"./exploring_laos_interoperability_scalability.md": [
		3737,
		737
	],
	"./introducing_universals.md": [
		5842,
		842
	],
	"./k_laos_is_live.md": [
		4382,
		382
	],
	"./laos_improves_inscriptions.md": [
		4091,
		91
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7347;
module.exports = webpackAsyncContext;